(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initHero = () => {
    const root = document.querySelector('[data-osea-hero]');
    if (!root) return;
    const slides = [...root.querySelectorAll('.osea-hero-slide')];
    const dots = [...root.querySelectorAll('.osea-hero-dot')];
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };
    const stop = () => timer && clearInterval(timer);
    const start = () => {
      stop();
      if (!reducedMotion) timer = setInterval(() => show(index + 1), 5000);
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    show(0);
    start();
  };

  const initCategories = () => {
    const root = document.querySelector('.osea-categories');
    if (!root) return;
    const cards = [...root.querySelectorAll('.osea-category-card')];
    if (!cards.length) return;

    const categoryMeta = [
      { target: '#papel-higienico', text: 'Jumbo y formatos profesionales' },
      { target: '#toallas-de-papel', text: 'Rollo e interfoliadas' },
      { target: '#jabones', text: 'Líquido y espuma' },
      { target: '#papeleria', text: 'Carta y oficio' }
    ];

    cards.forEach((card, cardIndex) => {
      const body = card.querySelector('.osea-category-card__body');
      const strong = body?.querySelector('strong');
      const arrow = body?.querySelector('span');
      if (!body || !strong || body.querySelector('.osea-category-card__copy')) return;

      const meta = categoryMeta[cardIndex];
      const count = meta ? document.querySelectorAll(`${meta.target} .osea-product-card`).length : 0;
      const copy = document.createElement('div');
      copy.className = 'osea-category-card__copy';
      const detail = document.createElement('small');
      detail.textContent = `${count ? `${count} productos · ` : ''}${meta?.text || 'Ver categoría'}`;
      body.insertBefore(copy, arrow || null);
      copy.appendChild(strong);
      copy.appendChild(detail);
    });

    let index = 0;
    let timer = null;
    let inView = true;

    const show = (nextIndex) => {
      index = (nextIndex + cards.length) % cards.length;
      cards.forEach((card, i) => card.classList.toggle('is-active', i === index));
    };

    const stop = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (!reducedMotion && inView && cards.length > 1) timer = setInterval(() => show(index + 1), 3200);
    };

    cards.forEach((card, i) => {
      card.addEventListener('mouseenter', () => { show(i); stop(); });
      card.addEventListener('mouseleave', start);
      card.addEventListener('focusin', () => { show(i); stop(); });
      card.addEventListener('focusout', start);
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        inView = Boolean(entries[0]?.isIntersecting);
        if (inView) start(); else stop();
      }, { threshold: 0.25 });
      observer.observe(root);
    }

    show(0);
    start();
  };

  const initFeaturedCopy = () => {
    const section = document.querySelector('#productos-destacados');
    if (!section) return;
    const heading = section.querySelector('.osea-section-title');
    const copy = section.querySelector('.osea-section-copy');
    if (heading) heading.textContent = 'Lo esencial para tu empresa.';
    if (copy) copy.textContent = 'Productos seleccionados para el abastecimiento diario de tu empresa.';
  };

  const initPurchaseFlowCopy = () => {
    const section = document.querySelector('#como-comprar');
    if (!section) return;
    const eyebrow = section.querySelector('.osea-eyebrow');
    const heading = section.querySelector('.osea-section-title');
    const copy = section.querySelector('.osea-section-copy');
    const steps = [...section.querySelectorAll('.osea-how__step')];
    if (eyebrow) eyebrow.textContent = 'COMPRA EN LÍNEA';
    if (heading) heading.textContent = 'Compra en tres pasos.';
    if (copy) copy.textContent = 'Selecciona tus productos, define cantidades y revisa el carrito. Para compras grandes, también puedes solicitar una condición empresa.';
    const content = [
      ['Elige productos', 'Revisa formato y precio IVA incluido.'],
      ['Añade cantidades', 'Usa Añadir al carrito o Compra rápida.'],
      ['Finaliza tu compra', 'Revisa el carrito y continúa al checkout.']
    ];
    steps.forEach((step, index) => {
      const strong = step.querySelector('strong');
      const small = step.querySelector('small');
      if (strong && content[index]) strong.textContent = content[index][0];
      if (small && content[index]) small.textContent = content[index][1];
    });
  };

  const initAnnouncementRotator = () => {
    const row = document.querySelector('.osea-announcement__row');
    const message = row?.querySelector(':scope > span:first-child');
    if (!row || !message) return;
    const messages = [
      'Despacho 1–2 días hábiles en Concepción',
      'Compra con Mercado Pago o transferencia',
      'Facturación para empresas',
      'Cotizaciones por volumen'
    ];
    let index = 0;
    let timer = null;
    message.setAttribute('aria-live', 'polite');
    message.textContent = messages[0];
    if (reducedMotion) return;

    const rotate = () => {
      message.classList.add('is-changing');
      setTimeout(() => {
        index = (index + 1) % messages.length;
        message.textContent = messages[index];
        message.classList.remove('is-changing');
      }, 220);
    };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };
    const start = () => { stop(); timer = setInterval(rotate, 4500); };
    row.addEventListener('mouseenter', stop);
    row.addEventListener('mouseleave', start);
    row.addEventListener('focusin', stop);
    row.addEventListener('focusout', start);
    start();
  };

  const initTrustStrip = () => {
    const benefits = document.querySelector('.osea-benefits');
    if (!benefits || document.querySelector('[data-osea-trust-strip]')) return;
    const labels = ['Facturación', 'Atención directa', 'Mercado Pago', 'Transferencia bancaria', 'Entrega coordinada', 'Precios empresa'];
    const section = document.createElement('section');
    section.className = 'osea-trust-strip';
    section.dataset.oseaTrustStrip = '';
    section.setAttribute('aria-label', 'Beneficios de compra OSEA');
    const viewport = document.createElement('div');
    viewport.className = 'osea-trust-strip__viewport';
    const track = document.createElement('div');
    track.className = 'osea-trust-strip__track';

    const makeGroup = (hidden = false) => {
      const group = document.createElement('div');
      group.className = 'osea-trust-strip__group';
      if (hidden) group.setAttribute('aria-hidden', 'true');
      labels.forEach((label) => {
        const item = document.createElement('span');
        item.className = 'osea-trust-strip__item';
        item.textContent = label;
        group.appendChild(item);
      });
      return group;
    };

    track.append(makeGroup(false), makeGroup(true));
    viewport.appendChild(track);
    section.appendChild(viewport);
    benefits.insertAdjacentElement('afterend', section);
  };

  const readProductCard = (handle) => {
    const card = document.querySelector(`#catalogo .osea-product-card[data-product-handle="${handle}"]`);
    if (!card) return null;
    const image = card.querySelector('.osea-product-card__media img');
    const titleLink = card.querySelector('h3 a');
    const mediaLink = card.querySelector('.osea-product-card__media[href]');
    const title = (titleLink?.textContent || card.querySelector('h3')?.textContent || '').trim();
    const vendor = (card.querySelector('.osea-product-card__vendor')?.textContent || 'OSEA').trim();
    const price = (card.querySelector('.osea-product-card__price')?.textContent || '').trim();
    const net = (card.querySelector('.osea-product-card__net')?.textContent || '').trim();
    return {
      handle,
      title,
      vendor,
      price,
      net,
      url: titleLink?.getAttribute('href') || mediaLink?.getAttribute('href') || `/#catalogo`,
      image: image?.currentSrc || image?.getAttribute('src') || '',
      alt: image?.getAttribute('alt') || title
    };
  };

  const initBusinessPicker = () => {
    const categories = document.querySelector('.osea-categories');
    const catalog = document.querySelector('#catalogo');
    if (!categories || !catalog || document.querySelector('[data-osea-business-picker]')) return;

    const profiles = [
      {
        label: 'Oficinas',
        note: 'Reposición práctica para baños, áreas comunes y administración.',
        handles: ['papel-fotocopia-equalit-carta', 'papel-higienico-elite-classic-jumbo', 'jabon-elite-economico-granel']
      },
      {
        label: 'Restaurantes',
        note: 'Insumos de alto uso para cocina, servicios higiénicos y atención diaria.',
        handles: ['toalla-elite-classic-jumbo-economica', 'jabon-elite-economico-granel', 'papel-higienico-rendipel-max']
      },
      {
        label: 'Colegios e instituciones',
        note: 'Formatos pensados para espacios con alta circulación y reposición frecuente.',
        handles: ['papel-higienico-elite-plus', 'toalla-elite-excellence-doble-hoja', 'jabon-elite-economico-granel']
      },
      {
        label: 'Empresas de aseo',
        note: 'Formatos profesionales para abastecimiento y operación recurrente.',
        handles: ['papel-higienico-elite-classic-jumbo', 'toalla-rendipel-max', 'jabon-elite-multiflex-espuma']
      }
    ];

    const section = document.createElement('section');
    section.className = 'osea-business-picker';
    section.dataset.oseaBusinessPicker = '';
    const shell = document.createElement('div');
    shell.className = 'osea-shell';
    section.appendChild(shell);

    const head = document.createElement('div');
    head.className = 'osea-business-picker__head';
    const intro = document.createElement('div');
    const eyebrow = document.createElement('span');
    eyebrow.className = 'osea-business-picker__eyebrow';
    eyebrow.textContent = 'COMPRA MÁS RÁPIDO';
    const heading = document.createElement('h2');
    heading.textContent = 'Compra según tu negocio.';
    const copy = document.createElement('p');
    copy.textContent = 'Selecciona tu tipo de operación y encuentra insumos recomendados para partir.';
    intro.append(eyebrow, heading, copy);
    const quick = document.createElement('a');
    quick.className = 'osea-business-picker__quick';
    quick.href = '/pages/compra-rapida';
    quick.textContent = 'Ir a Compra rápida →';
    head.append(intro, quick);

    const tabs = document.createElement('div');
    tabs.className = 'osea-business-picker__tabs';
    tabs.setAttribute('role', 'tablist');
    tabs.setAttribute('aria-label', 'Tipo de negocio');

    const panel = document.createElement('div');
    panel.className = 'osea-business-picker__panel';
    panel.setAttribute('role', 'tabpanel');
    const grid = document.createElement('div');
    grid.className = 'osea-business-picker__grid';
    const reason = document.createElement('p');
    reason.className = 'osea-business-picker__reason';
    panel.append(grid, reason);

    const render = (profileIndex) => {
      const profile = profiles[profileIndex];
      panel.classList.add('is-changing');
      const doRender = () => {
        grid.replaceChildren();
        profile.handles.map(readProductCard).filter(Boolean).forEach((product) => {
          const card = document.createElement('a');
          card.className = 'osea-business-picker__card';
          card.href = product.url;
          const media = document.createElement('div');
          media.className = 'osea-business-picker__media';
          if (product.image) {
            const img = document.createElement('img');
            img.src = product.image;
            img.alt = product.alt;
            img.loading = 'lazy';
            media.appendChild(img);
          }
          const body = document.createElement('div');
          body.className = 'osea-business-picker__body';
          const vendor = document.createElement('small');
          vendor.textContent = product.vendor;
          const title = document.createElement('h3');
          title.textContent = product.title;
          const price = document.createElement('span');
          price.className = 'osea-business-picker__price';
          price.textContent = product.price;
          const net = document.createElement('span');
          net.className = 'osea-business-picker__net';
          net.textContent = product.net;
          const cta = document.createElement('span');
          cta.className = 'osea-business-picker__cta';
          cta.textContent = 'Ver producto →';
          body.append(vendor, title, price, net, cta);
          card.append(media, body);
          grid.appendChild(card);
        });
        reason.textContent = profile.note;
        tabs.querySelectorAll('.osea-business-picker__tab').forEach((tab, i) => {
          tab.setAttribute('aria-selected', i === profileIndex ? 'true' : 'false');
          tab.tabIndex = i === profileIndex ? 0 : -1;
        });
        panel.classList.remove('is-changing');
      };
      if (reducedMotion) doRender(); else setTimeout(doRender, 150);
    };

    profiles.forEach((profile, i) => {
      const tab = document.createElement('button');
      tab.className = 'osea-business-picker__tab';
      tab.type = 'button';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      tab.tabIndex = i === 0 ? 0 : -1;
      tab.textContent = profile.label;
      tab.addEventListener('click', () => render(i));
      tabs.appendChild(tab);
    });

    shell.append(head, tabs, panel);
    categories.insertAdjacentElement('afterend', section);
    render(0);
  };

  const initProductBadges = () => {
    const labels = {
      'papel-higienico-elite-classic-jumbo': 'Formato profesional',
      'papel-higienico-elite-excellence': 'Doble hoja',
      'papel-higienico-rendipel-max': '500 m',
      'toalla-elite-classic-jumbo-economica': '250 m',
      'toalla-elite-plus-ecologica': 'Ecológica',
      'jabon-elite-economico-granel': 'Formato 5 L',
      'jabon-elite-multiflex-espuma': 'Jabón espuma',
      'papel-fotocopia-equalit-carta': '500 hojas',
      'papel-fotocopia-equalit-oficio': '500 hojas'
    };
    document.querySelectorAll('.osea-product-card').forEach((card) => {
      const handle = card.dataset.productHandle;
      const label = labels[handle];
      const media = card.querySelector('.osea-product-card__media');
      if (!label || !media || media.querySelector('.osea-product-badge')) return;
      const badge = document.createElement('span');
      badge.className = 'osea-product-badge';
      badge.textContent = label;
      media.appendChild(badge);
    });
  };

  const initHeroParallax = () => {
    const hero = document.querySelector('.osea-hero');
    if (!hero || reducedMotion || matchMedia('(max-width: 760px)').matches) return;
    let ticking = false;
    const update = () => {
      const rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight) {
        ticking = false;
        return;
      }
      const center = rect.top + rect.height / 2;
      const distance = (center - innerHeight / 2) / innerHeight;
      const offset = Math.max(-13, Math.min(13, distance * -18));
      hero.style.setProperty('--osea-hero-parallax', `${offset.toFixed(1)}px`);
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    update();
  };

  const initWhatsAppNudge = () => {
    const fab = document.querySelector('.osea-whatsapp-fab');
    if (!fab || document.querySelector('.osea-whatsapp-nudge')) return;
    const nudge = document.createElement('div');
    nudge.className = 'osea-whatsapp-nudge';
    const link = document.createElement('a');
    link.href = 'https://wa.me/56976408359?text=Hola%20OSEA%2C%20necesito%20cotizar%20una%20compra%20por%20volumen.';
    link.target = '_blank';
    link.rel = 'noopener';
    link.textContent = '¿Necesitas cotizar por volumen?';
    const small = document.createElement('small');
    small.textContent = 'Te ayudamos directamente por WhatsApp.';
    link.appendChild(small);
    const close = document.createElement('button');
    close.className = 'osea-whatsapp-nudge__close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Cerrar mensaje');
    close.textContent = '×';
    nudge.append(link, close);
    fab.insertAdjacentElement('beforebegin', nudge);

    let hideTimer;
    const hide = () => {
      nudge.classList.remove('is-visible');
      if (hideTimer) clearTimeout(hideTimer);
    };
    close.addEventListener('click', hide);
    link.addEventListener('click', hide);
    fab.addEventListener('click', hide);
    setTimeout(() => {
      nudge.classList.add('is-visible');
      hideTimer = setTimeout(hide, 9000);
    }, 5000);
  };

  const initScrollReveal = () => {
    const selectors = [
      '.osea-section-head',
      '.osea-benefit',
      '.osea-category-card',
      '.osea-business-picker__head',
      '.osea-business-picker__tabs',
      '.osea-product-section__head',
      '.osea-product-card',
      '.osea-how__step',
      '.osea-business-cta__inner'
    ];
    const elements = [...document.querySelectorAll(selectors.join(','))];
    if (!elements.length) return;
    elements.forEach((el, index) => {
      el.classList.add('osea-reveal');
      el.style.setProperty('--osea-reveal-delay', `${(index % 4) * 70}ms`);
    });
    document.body.classList.add('osea-life-ready');

    if (reducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach((el) => el.classList.add('is-revealed'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
    elements.forEach((el) => observer.observe(el));
  };

  document.addEventListener('DOMContentLoaded', () => {
    initHero();
    initCategories();
    initFeaturedCopy();
    initPurchaseFlowCopy();
    initAnnouncementRotator();
    initTrustStrip();
    initBusinessPicker();
    initProductBadges();
    initHeroParallax();
    initWhatsAppNudge();
    initScrollReveal();
  });
})();
